// What the screens of the party domain share (50-api/party.md): the roots of their cache keys. A role names what a
// user holds and a user is counted on its roles, so a write on one reloads the other; the contacts and addresses of an
// organization are under its keys, since they are part of its history and a merge moves them.

export const partyQueries = {
  all: ["party"] as const,
  organizationDetails: ["party", "organizations", "detail"] as const,
};
